import { find, intersectionWith } from 'lodash';

import {
  Group,
  GroupColor,
  GroupColorMap,
  GroupModerator,
  ProfileSuggestion,
  PublicUserProfile,
  UserProfile,
} from 'api';
import { isAdminUser } from 'helpers';

type Profile = UserProfile | PublicUserProfile;
export type Managers = ProfileSuggestion & GroupModerator;

export const getModeratedGroups = (user: Profile, groups: Group[]) => {
  const { group_moderator } = user;

  if (!group_moderator) {
    return [];
  }

  return intersectionWith(groups, group_moderator, (first, second) => first.id === second.group_id);
};

export const getFollowedOnlyGroups = (user: Profile, groups: Group[]) => {
  const { group_moderator } = user;

  if (!group_moderator) {
    return groups;
  }

  const moderatedIds = group_moderator.map(moderator => moderator.group_id);
  return groups.filter(group => !moderatedIds.includes(group.id));
};

export const getGroupModerator = (user: Profile, groupId: string) => {
  return find(user.group_moderator, ['group_id', groupId]);
};

export const isGroupOwnerOrModerator = (user: Profile, groupId: string) => {
  return !!getGroupModerator(user, groupId) || isAdminUser(user);
};

export const canModerateGroupContent = (user: Profile, groupId: string) =>
  isGroupOwnerOrModerator(user, groupId) || isAdminUser(user);

export const isGroupOwner = (user: Profile, groupId: string) => {
  const moderator = getGroupModerator(user, groupId);

  if (!moderator) {
    return false;
  }

  const { added_by_user_id, user_id } = moderator;
  return added_by_user_id === user_id;
};

export const moderatorIsOwner = (moderator: Partial<GroupModerator>) =>
  moderator.user_id === moderator.added_by_user_id;

export const getGroupHexColor = (groupColors: GroupColorMap[], color: GroupColor) => {
  return find(groupColors, ['group_color', color]).hex;
};
